import { usePreviewData } from 'framework-asset-preview-lib/internal/shared/providers/DataProvider';
export default function usePropertyGroups() {
  const {
    propertyGroups
  } = usePreviewData();
  return propertyGroups;
}